import { useCallback, useState } from 'react';

export const useFormErrors = () => {
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

  const clearErrors = useCallback(() => {
    setFieldErrors({});
  }, []);

  const setError = (field: string, message: string) => {
    setFieldErrors((prev) => ({ ...prev, [field]: message }));
  };

  /** Extrae el primer mensaje de error de valores anidados (ej: { addresses: { addresses: "msg" } }) */
  const extractMessage = (val: any): string | null => {
    if (typeof val === 'string') return val;
    if (Array.isArray(val) && val[0]) return typeof val[0] === 'string' ? val[0] : extractMessage(val[0]);
    if (val && typeof val === 'object') {
      const first = Object.values(val)[0];
      return first ? extractMessage(first) : null;
    }
    return null;
  };

  const setErrorsFromResponse = (resp: any) => {
    if (!resp) return;

    const newErrors: Record<string, string> = {};
    const errors = resp?.errors ?? resp?.data ?? {};

    // Caso 1: lista de objetos [{"name": ["msg"]}]
    if (Array.isArray(errors)) {
      errors.forEach((errObj) => {
        Object.entries(errObj).forEach(([field, messages]) => {
          const msg = extractMessage(messages);
          if (msg) newErrors[field] = msg;
        });
      });
    }

    // Caso 2: objeto plano {"name": ["msg"]} | {"name": "msg"} | {"name": {"nested": "msg"}}
    else if (typeof errors === 'object' && !Array.isArray(errors)) {
      Object.entries(errors).forEach(([field, messages]) => {
        const msg = extractMessage(messages);
        if (msg) newErrors[field] = msg;
      });
    }

    setFieldErrors(newErrors);
  };

  const getError = (field: string): string | undefined => fieldErrors[field];

  return {
    fieldErrors,
    clearErrors,
    setError,
    setErrorsFromResponse,
    getError,
  };
};